import { Icon, useControllableState, useDisclosure } from "@chakra-ui/react";
import { config } from "config";
import { NurseHat } from "icons";
import * as React from "react";
import {
  MedicalStaffInputProps,
  MedicalStaffModal,
  MedicalStaffModalBaseProps,
  MedicalStaffModalContent,
} from "../MedicalStaffInput";
import { ModalInputButton } from "../ModalInputButton";

function ChargeNurseModal(props: MedicalStaffModalBaseProps) {
  const { isOpen, onClose, onChange, initialValue, ...rest } = props;

  return (
    <MedicalStaffModal isOpen={isOpen} onClose={onClose}>
      {isOpen && (
        <MedicalStaffModalContent
          onClose={onClose}
          title="Assign Charge Nurse"
          initialValue={initialValue}
          onChange={onChange}
          {...rest}
        />
      )}
    </MedicalStaffModal>
  );
}

const ChargeNurseInput = React.forwardRef<
  HTMLButtonElement,
  MedicalStaffInputProps
>((props, ref) => {
  const {
    defaultValue = null,
    onChange,
    value: valueProp,
    encounterId,
    encounterUserType,
    userType,
    onCloseDetailsModal,
    disabled = false,
  } = props;
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [value, setValue] = useControllableState({
    defaultValue,
    onChange,
    value: valueProp,
  });

  return (
    <>
      <ModalInputButton
        ref={ref}
        icon={<Icon as={NurseHat} fontSize="1.25rem" color="gray.600" />}
        label="Charge Nurse"
        value={value?.fullName || ""}
        onClick={onOpen}
        disabled={disabled}
      />
      <ChargeNurseModal
        isOpen={isOpen}
        onClose={onClose}
        onChange={setValue}
        initialValue={value}
        encounterId={encounterId}
        encounterUserType={encounterUserType}
        userType={userType}
        onCloseDetailsModal={onCloseDetailsModal}
      />
    </>
  );
});

if (config.isDev) {
  ChargeNurseInput.displayName = "ChargeNurseInput";
}

export { ChargeNurseInput };
